// message visible for co-owners and participants when sharing the invite link
export const INVITE_MESSAGE = `Doe je mee aan het boek? Het is super eenvoudig. Klik op de link en vul je pagina's. Je kan alles naar wens aanpassen en je bijdragen worden automatisch opgeslagen. Dank je wel!`;
